module.exports = __webpack_public_path__ + "media/jungle_2_TA.1bc08ea5.mp4";